import { Component, Host, h, Prop, Element } from '@stencil/core';
import { addIntersectionObserver } from '../../utils/utils';

@Component({
  tag: 'cta-blocks',
  styleUrl: 'cta-blocks.css',
  shadow: true,
})
export class CtaBlocks {
  /**
   * Cards Data
   */
  @Prop() cardsData: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  @Element() el: HTMLElement;

  componentDidLoad() {
    addIntersectionObserver(
      this.el.shadowRoot.querySelector('.cta-block-section'),
      () => {
        this.el.shadowRoot.querySelector('.cta-block-section').classList.add('animate');
      },
      ['.overlay1', '.overlay2', '.overlay3', '.overlay4'],
    );
  }

  render() {
    const cards = JSON.parse(this.cardsData);
    const count = cards.length;
    //console.log('cards', cards)
    //console.log('data', this.imageUrl);
    return (
      <Host>
        <div class={`${this.paddingBottom} ${this.paddingTop} container cta-block-section relative rounded-xl`} style={{ backgroundImage: `url(${this.backgroundImage})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
          <div class={` cta-block-container  ${count === 1 && this.backgroundColor}  ${this.textColor} layout-${count}`}>
          {count === 1 && <div class={`overlay1 `}></div>}
            {cards.length > 0 &&
              cards.map(({ title, supertitle, subtitle, buttons, icon, icon_alt }, index) => (
                <div class={`cta-block-card ${count > 1 && this.backgroundColor} `}>
                  {count > 1 && <div class={`overlay${index + 1}`}></div>}
                  <div class=" max-w-xs">{icon && <image-block imageUrl={icon} imageAlt={icon_alt}></image-block>}</div>
                  {supertitle && <p class={`cta-block-super-title`}>{supertitle}</p>}
                  {title && <h3 class={`cta-block-title`}>{title}</h3>}
                  {buttons && buttons.length > 0 && (
                    <div class="button-container">
                      {buttons.map(button => (
                        <button-block buttonsData={button}></button-block>
                      ))}
                    </div>
                  )}
                  {subtitle && <h4 class={`pt-16px`}>{subtitle}</h4>}
                </div>
              ))}
          </div>
        </div>
      </Host>
    );
  }
}
